import {
    requestAllMytodos,
    requestSaveMytodo,
    requestDeleteMytodo
} from "@/api/todo-api";

const actions = {

    async getAllMytodos({commit}, data) {
        let result = await requestAllMytodos(data)
        if (result.code === '200') {
            return result
        } else {
            return Promise.reject(new Error('無法取得資料'))
        }
    },

    async saveMytodo({commit}, data) {
        let result = await requestSaveMytodo(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('資料更新失敗'))
        }
    },

    async deleteMytodo({commit}, data) {
        let result = await requestDeleteMytodo(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('資料刪除失敗'))
        }
    }
}

const mutations = {}
const state = {}
const getters = {}

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters
}
